"use client";

import { AuditChooserForm } from "~/components/siteglue/home/audit-chooser-form";
import { DemoCTA, PrimaryCTA } from "~/components/siteglue/siteglue-cta";
import { FadeIn, HomeSection } from "~/components/siteglue/home/section-shell";
import { HOMEPAGE_HERO_H1, HOMEPAGE_HERO_SUPPORT } from "~/lib/siteglue/landing-redesign/copy";

export function SiteGlueHomeFinalCta({
  variant = "legacy",
}: {
  variant?: "legacy" | "url" | "audit";
} = {}) {
  if (variant === "url" || variant === "audit") {
    return (
      <HomeSection id="get-started" tone="brand" className="overflow-hidden py-16 sm:py-20">
        <FadeIn className="relative mx-auto max-w-3xl">
          <h2 className="text-balance text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {HOMEPAGE_HERO_H1}
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
            {HOMEPAGE_HERO_SUPPORT}
          </p>
          <div className="mt-6 rounded-3xl bg-white p-5 text-slate-900">
            <AuditChooserForm location="homepage_final" />
          </div>
        </FadeIn>
      </HomeSection>
    );
  }

  return (
    <HomeSection id="get-started" tone="brand" className="overflow-hidden">
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        aria-hidden
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 0%, #4f81bd88, transparent 60%)",
        }}
      />
      <FadeIn className="relative mx-auto max-w-2xl text-center">
          <h2 className="text-balance text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {HOMEPAGE_HERO_H1}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300">
            {HOMEPAGE_HERO_SUPPORT}
          </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <PrimaryCTA location="final_cta" size="lg" testId="button-home-final-signup" />
          <DemoCTA
            location="final_cta"
            size="lg"
            variant="secondary"
            className="border-white/20 bg-white/5 text-white hover:bg-white/10"
            testId="button-home-final-live-demo"
          />
        </div>
      </FadeIn>
    </HomeSection>
  );
}
